import axios from "axios";
import qs from "qs";

export const getCategories = async (params: any): Promise<{
    list: {
        code: string,
        label: string
    }[]
}> => {
    const response = await axios.get('/booking/rule/categories', {
        params: { ...params, tenants: params.tenants?.join(',') || "", dealers: params.dealers?.join(',') || "drivalia" },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
    })
    return response.data;
};
